import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPredefinedValueFilterOption {
  k: string;
  v: string;
  label: string;
  value: string;
}

export interface IPredefinedValueFieldFilter {
  searchByValueOrDescription: string;
  propertyFilters: IPredefinedValueFilterOption[];
}

export interface IPredefinedValueField {
  fieldName: string;
  filter: IPredefinedValueFieldFilter;
}

type TPredefinedValueFiltersState = {
  filtersByField: IPredefinedValueField[];
};

const initialState: TPredefinedValueFiltersState = {
  filtersByField: [],
};

const slice = createSlice({
  name: "predefinedValueFilters",
  initialState,
  reducers: {
    setFieldFilterAction(state, action: PayloadAction<IPredefinedValueField>) {
      const { fieldName } = action.payload;
      const fieldExistIndex = state?.filtersByField?.findIndex(
        (field) => field.fieldName === fieldName,
      );
      if (fieldExistIndex === -1) {
        state?.filtersByField?.push(action.payload);
        return;
      }
      state.filtersByField = state?.filtersByField?.map((filter, index) => {
        if (index === fieldExistIndex) {
          return action.payload;
        }
        return filter;
      });
    },

    clearFieldFilterAction(state, action: PayloadAction<string>) {
      const fieldName = action.payload;
      const fieldExistIndex = state?.filtersByField?.findIndex(
        (field) => field.fieldName === fieldName,
      );
      if (fieldExistIndex !== -1) {
        state.filtersByField?.splice(fieldExistIndex, 1);
      }
    },

    clearAllFieldFiltersAction(state) {
      state.filtersByField = [];
    },
  },
});

export default slice.reducer;

export const {
  setFieldFilterAction,
  clearFieldFilterAction,
  clearAllFieldFiltersAction,
} = slice.actions;

export function setFieldFilter(
  fieldName: string,
  filter: IPredefinedValueFieldFilter,
) {
  return (dispatch) => {
    dispatch(setFieldFilterAction({ fieldName, filter }));
  };
}

export function clearFieldFilter(fieldName: string) {
  return (dispatch) => {
    dispatch(clearFieldFilterAction(fieldName));
  };
}

export function clearAllFieldFilters() {
  return (dispatch) => {
    dispatch(clearAllFieldFiltersAction());
  };
}
